import { render, staticRenderFns } from "./homepage.tt.vue?vue&type=template&id=7a9b197e&scoped=true"
import script from "./homepage.tt.vue?vue&type=script&lang=js"
export * from "./homepage.tt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9b197e",
  null
  
)

export default component.exports